import img from '~/src/assets/br1_logo.webp'

export function Logo() {
    return (
        <div className='[container-type:inline-size]'>
            {/*
              Stacked on a phone, side by side from md.

              The logo and the headline used to share a row at every width, and because both are
              sized off the same container-query scale, the pair simply shrank until it fitted:
              "EXTRACTION SHOOTER" came out at 12px on a 375px screen. Giving each its own full
              width is what lets the type be a readable size instead of a proportional one.

              The `max()` floor is the same idea as `HeroButton` next door — scale up with the
              container, but never below something you can read.
            */}
            <div className='flex flex-col items-center gap-[1em] text-[max(1cqi,10px)] my-[3em] md:mx-auto md:grid md:w-max md:grid-cols-[auto_1fr] md:items-center md:gap-0'>
                <div
                    className='bg-no-repeat bg-contain bg-center h-[4em] w-[14.3em] md:h-[6em] md:w-auto md:flex-1'
                    style={{ aspectRatio: '508/142', backgroundImage: `url(${img})` }}
                ></div>
                <div className='flex flex-col font-bold leading-none text-center md:flex-1 md:py-[1em] md:w-min md:text-left'>
                    <h1 className='flex flex-col'>
                        <span className='text-[1.6em] whitespace-nowrap'>
                            THE WORLD'S FIRST{' '}
                            <span
                                className='gradient-text'
                                style={{ backgroundImage: 'linear-gradient(90deg, #C91FFF 0%, #03CEFF 100%)' }}
                            >
                                REAL MONEY
                            </span>
                        </span>
                        {/* Plain white on purpose. With the gradient on both lines the eye had
                            nothing to land on; keeping it on REAL MONEY alone is what makes that
                            phrase the emphasis rather than the whole headline being decorated. */}
                        <span className='text-[2.4em] whitespace-nowrap'>EXTRACTION SHOOTER</span>
                    </h1>
                </div>
            </div>
        </div>
    )
}
